/**
 * チームの初期値を決める。
 * 自分のチーム(preferredTeamId)が候補に在ればそれを、無ければ候補の先頭を返す。
 * 候補が空のときは null。
 */
export const pickInitialTeamValue = (
  optionValues: readonly string[],
  preferredTeamId: unknown
): string | null => {
  if (optionValues.length === 0) return null;
  const preferred = String(preferredTeamId ?? '').trim();
  if (preferred && optionValues.includes(preferred)) return preferred;
  return optionValues[0];
};
